const root = `/td-register/archive/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'list',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'detail',
  update: root + 'update',
  search: root + 'search',
  archiveIntoSearchDataSync: root + 'archiveIntoSearchDataSync'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const search = obj => {
  return $http.get(urls.search, obj)
}
//同步
export const archiveIntoSearchDataSync = obj => {
  return $http.get(urls.archiveIntoSearchDataSync, obj, { timeout: 0 })
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  search,
  archiveIntoSearchDataSync
}
